import { DESCRIPTIONS } from '../../../../modules/trade-approval/constants'
import { ModalHeader, SimpleModal, Space, Typography } from '../..'
import Icon from '../../atoms/Icon/Icon'
import IconButton from '../../molecules/iconButton/iconButton'

export type TradeDeleteModalProps = {
  onClose: () => void
  onDelete: () => void
}

export const TradeDeleteModal = ({ onClose, onDelete }: TradeDeleteModalProps) => (
  <SimpleModal>
    <ModalHeader onClickClose={() => onClose()}>Confirm draft trade deletion</ModalHeader>
    <Space p={6}>
      <Space mb={6}>
        <Typography fontSize={13} variant="b3">
          {DESCRIPTIONS.DELETE_DRAFT_TRADE_CONFIRM}
        </Typography>
      </Space>
      <Space isinlineblock mr={2}>
        <IconButton
          disabled={false}
          icon={<Icon name="bin" size="medium" />}
          iconPosition="left"
          operationType="negative"
          text="Delete draft trade"
          onClick={() => onDelete()}
        />
      </Space>
      <Space isinlineblock ml={2}>
        <IconButton
          disabled={false}
          icon={<Icon name="circleX" size="medium" />}
          iconPosition="left"
          operationType="cancel"
          text="Cancel"
          onClick={() => onClose()}
        />
      </Space>
    </Space>
  </SimpleModal>
)

export default TradeDeleteModal
